import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=15b0ffff&scoped=true&"
import script from "./PageLayout.vue?vue&type=script&lang=ts&"
export * from "./PageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=15b0ffff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b0ffff",
  null
  
)

export default component.exports